// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ViewStack = require("../ViewStack.bs.js");
let Attachments = require("./Attachments.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function UnsupportedAttachmentsDialog(props) {
  let onDismiss = props.onDismiss;
  let files = props.files;
  let isOpen = files.length !== 0;
  return JsxRuntime.jsx(DialogV5.make, {
    title: "Unsupported Files",
    isOpen: isOpen,
    ariaLabel: "Unsupported Files",
    onDismiss: onDismiss,
    children: JsxRuntime.jsxs(ViewStack.make, {
      space: "lg",
      flexDirection: "column",
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            Attachments.makeUnsupportedFileErrorText(files),
            JsxRuntime.jsx("br", {}),
            JsxRuntime.jsx("br", {}),
            "You can attach images (JPEG, PNG, GIF, PNG), videos (MP4, Quicktime), PDFs, documents and spreadsheets"
          ],
          className: "text-lg leading-normal"
        }),
        JsxRuntime.jsx(ViewStack.make, {
          width: {
            NAME: "percent",
            VAL: "p100"
          },
          justifyContent: "flexEnd",
          flexDirection: "row",
          children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            onClick: param => onDismiss(),
            size: "large",
            children: "Dismiss"
          })
        })
      ]
    })
  });
}

let make = UnsupportedAttachmentsDialog;

exports.make = make;
/* DialogV5 Not a pure module */
